<template>
  <div class="content-card">
    <template v-if="$route.params.articles == 'How-to-Order-Glasses-Online'">
      <div class="card-body">
        <h1 class="content-title">{{ content.title }}</h1>
        <div class="stepper-box">
          <div class="stepper-track">
            <div v-for="index in flowNum" :key="index" class="stepper-step" :class="{ active: index == currentFlow, completed: index < currentFlow }" @click="changeFlow(index)">
              <div class="step-dot">
                <span class="step-num">{{ index }}</span>
              </div>
              <span class="step-label">Step</span>
            </div>
          </div>
        </div>
        <div class="flow-preview">
          <transition name="img-fade">
            <img v-if="image_flag" :key="currentFlow" :src="currentImg" alt="step" class="flow-image" @click="lookImg" />
          </transition>
        </div>
      </div>
      <components :is="renderCom" v-if="$vuetify.breakpoint.mobile" :show="imgDiologs" :list="[currentImg]" />
    </template>
    <template v-else>
      <div class="card-body">
        <h1 class="content-title">{{ content.title }}</h1>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="content-text" v-html="sanitizedContent"></div>
        <template v-if="$route.params.articles == 'How-to-Measure-Your-PD'">
          <div class="button-box">
            <a class="download-btn" download target="_blank" :href="`${GLOBAL.URL}/materials/download/Stylool-PD-Ruler.pdf`">
              <span class="btn-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
              </span>
              DOWNLOAD STYLOOL'S PD RULER
            </a>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import DOMPurify from 'dompurify'
const imgDialog = () => import('@/components/Ldetails/components/imgDialog.vue')
export default {
  name: 'contentFaq',
  props: {
    content: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      flowNum: 7,
      imgDiologs: false,
      currentFlow: 1,
      image_flag: true,
      flowImg: ['step-1.png', 'step-2.png', 'step-3.png', 'step-4.png', 'step-5.png', 'step-6.png', 'step-7.png']
    }
  },
  computed: {
    sanitizedContent() {
      if (process.server) {
        return this.content.content
      }
      return DOMPurify.sanitize(this.content.content)
    },
    currentImg() {
      return '/imgs/flow/' + this.flowImg[this.currentFlow - 1]
    },
    renderCom() {
      if (this.$route.params.articles === 'How-to-Order-Glasses-Online') {
        return imgDialog
      }
      return ''
    }
  },
  watch: {
    currentFlow(val, old) {
      if (val !== old) {
        this.image_flag = false
        setTimeout(() => {
          this.image_flag = true
        }, 150)
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    changeFlow(index) {
      this.currentFlow = index
    },
    lookImg() {
      if (this.$vuetify.breakpoint.mobile) {
        this.imgDiologs = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-card {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}
.card-body {
  padding: 36px 40px;
}
.content-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
  text-align: center;
  margin-bottom: 28px;
  letter-spacing: -0.5px;
  line-height: 1.3;
}
.content-text {
  font-size: 15px;
  color: #4a4f5a;
  line-height: 1.8;
  ::v-deep p {
    margin-bottom: 24px;
  }
  ::v-deep img {
    width: 100%;
    border-radius: 8px;
    margin: 8px 0;
  }
  ::v-deep a {
    color: #3067f2;
    text-decoration: none;
    font-weight: 500;
  }
  ::v-deep strong {
    color: #1a1a2e;
  }
  ::v-deep h2,
  ::v-deep h3,
  ::v-deep h4 {
    color: #1a1a2e;
    margin-top: 32px;
    margin-bottom: 16px;
  }
}

.stepper-box {
  margin-bottom: 24px;
}
.stepper-track {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  flex-wrap: wrap;
}
.stepper-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 0 16px;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.stepper-step::after {
  content: '';
  position: absolute;
  top: 18px;
  left: calc(50% + 18px);
  width: calc(100% - 36px);
  height: 2px;
  background: #e5e7eb;
  border-radius: 1px;
  transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.stepper-step:last-child::after {
  display: none;
}
.stepper-step.completed::after {
  background: #3067f2;
}
.step-dot {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f3f4f6;
  border: 2px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  margin-bottom: 8px;
}
.step-num {
  font-size: 13px;
  font-weight: 700;
  color: #9ca3af;
  transition: color 0.3s;
}
.step-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: color 0.3s;
}
.stepper-step.active .step-dot {
  background: #3067f2;
  border-color: #3067f2;
  box-shadow: 0 0 0 4px rgba(48, 103, 242, 0.15);
  transform: scale(1.1);
}
.stepper-step.active .step-num {
  color: #fff;
}
.stepper-step.active .step-label {
  color: #3067f2;
}
.stepper-step.completed .step-dot {
  background: #e8edf8;
  border-color: #3067f2;
}
.stepper-step.completed .step-num {
  color: #3067f2;
}
.stepper-step.completed .step-label {
  color: #6b7280;
}
.stepper-step:hover .step-dot {
  border-color: #3067f2;
}
.stepper-step:hover .step-num {
  color: #3067f2;
}
.stepper-step.active:hover .step-dot {
  border-color: #3067f2;
}
.stepper-step.active:hover .step-num {
  color: #fff;
}

.flow-preview {
  background: #fafbfc;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
}
.flow-image {
  width: 100%;
  max-width: 560px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.img-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.img-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.img-fade-enter {
  opacity: 0;
  transform: translateY(12px) scale(0.96);
}
.img-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px) scale(0.98);
}

.button-box {
  text-align: center;
  margin-top: 12px;
}
.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #fff !important;
  text-decoration: none;
  padding: 14px 32px;
  border-radius: 50px;
  background: linear-gradient(135deg, #3067f2 0%, #4f7df5 100%);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 14px rgba(48, 103, 242, 0.3);
}
.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(48, 103, 242, 0.4);
  color: #fff !important;
  text-decoration: none;
}
.download-btn:active {
  transform: translateY(0);
}
.btn-icon {
  display: flex;
  align-items: center;
}

.nav-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  font-size: 13px;
  background: #f2f2f2;
  color: #2b2e33;
  padding: 0 15px;
  img {
    width: 14px;
    height: 14px;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 960px) {
  .content-card {
    border-radius: 0;
    box-shadow: none;
  }
  .card-body {
    padding: 24px 20px;
  }
  .content-title {
    font-size: 22px;
    margin-bottom: 20px;
  }
  .content-text {
    font-size: 14px;
    line-height: 1.7;
  }
  .stepper-track {
    justify-content: flex-start;
    gap: 0;
    overflow-x: auto;
    padding-bottom: 8px;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      height: 3px;
    }
  }
  .stepper-step {
    padding: 0 12px;
    flex-shrink: 0;
  }
  .stepper-step::after {
    top: 14px;
    left: calc(50% + 14px);
    width: calc(100% - 28px);
  }
  .step-dot {
    width: 28px;
    height: 28px;
  }
  .step-num {
    font-size: 11px;
  }
  .step-label {
    font-size: 10px;
  }
  .stepper-step.active .step-dot {
    box-shadow: 0 0 0 3px rgba(48, 103, 242, 0.15);
    transform: scale(1.05);
  }
  .flow-preview {
    padding: 16px;
    min-height: 180px;
  }
  .flow-image {
    max-width: 100%;
    border-radius: 6px;
  }
  .button-box {
    text-align: center;
  }
  .download-btn {
    width: 100%;
    justify-content: center;
    padding: 12px 24px;
    font-size: 13px;
    border-radius: 40px;
  }
}
</style>
